var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTipicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2604 2.94218C9.52742 0.20953 5.09634 0.209225 2.36308 2.94218C-0.369876 5.67513 -0.369572 10.1062 2.36308 12.8395C5.09603 15.5718 9.52712 15.5721 12.2604 12.8395C14.993 10.1062 14.9927 5.67544 12.2604 2.94218ZM8.22423 10.9335C8.22423 11.4377 7.8156 11.8463 7.31142 11.8463C6.80725 11.8463 6.39861 11.4377 6.39861 10.9335V7.28229C6.39861 6.77811 6.80725 6.36948 7.31142 6.36948C7.8156 6.36948 8.22423 6.77811 8.22423 7.28229V10.9335ZM7.2953 5.72199C6.76952 5.72199 6.419 5.34957 6.42995 4.88981C6.419 4.40785 6.76952 4.04668 7.30595 4.04668C7.84268 4.04668 8.18224 4.40815 8.1935 4.88981C8.1932 5.34957 7.84298 5.72199 7.2953 5.72199Z",
    fill: "#5D35E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipicon);
export default __webpack_public_path__ + "static/media/tipicon.eab2d60439b183a9d5eaee4b42f81399.svg";
export { ForwardRef as ReactComponent };